<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="12">
        <b-card :sub-title="$t('Services')" sub-title-text-variant="" class="stats-panel">
          <StatsPanel
            :url="url"
            :colors="svcStatsColors"
            :timeRange="timeRange"
            routeName="app"
            chartName="top-services-alert"
            :isSvcApp="true"
          ></StatsPanel>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StatsPanel from '@/xvisor/components/launchPad/StatsPanel.vue';
import colorPaletteShade from '@/xvisor/constants/colorPaletteShade';

export default {
  components: {
    StatsPanel,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      svcStatsColors: [
        colorPaletteShade.blue7,
        colorPaletteShade.blue3,
        colorPaletteShade.blue5,
        colorPaletteShade.blue2,
        colorPaletteShade.blue4,
        colorPaletteShade.blue6,
        colorPaletteShade.blue3,
      ],
    };
  },
};
</script>

<style scoped>
.stats-panel {
  margin-top: 70px;
}
</style>
